import storage from 'utils/storage'
function createElement(tag, id) {
  const el = document.getElementById(id)
  if (el) return el
  const div = document.createElement(tag)
  div.id = id
  document.body.appendChild(div)
  return div
}
export default {
  install(Vue) {
    Vue.$showAppInMaintenance = function(msg) {
      msg = msg || { title: 'Sorry', content: '服务器维护中，请稍候再试' }
      const appMaintenance = createElement('div', 'app-maintenance')
      const content = `
        <h2>${msg.title}</h2>
        <p>${msg.content}</p>
        <a href="javascript:location.reload()">刷新</a>
      `
      appMaintenance.innerHTML = content
    }
    Vue.$showBrowserTips = function() {
      let isIE = false
      if (window.ActiveXObject || 'ActiveXObject' in window) {
        isIE = true
      }
      const isEdge = navigator.userAgent.indexOf('Edge') > -1
      const showBrowserTips = storage.get('show-browser-tip')
      // IE非Edge浏览器提示
      if (isIE && !isEdge && !showBrowserTips) {
        const el = createElement('div', 'browser-tip')
        const fragment = document.createDocumentFragment()
        const p = document.createElement('p')
        p.className = 'browser-tip-text'
        p.innerText = Vue.t('browserTip')
        const span = document.createElement('span')
        span.className = 'browser-tip-close'
        span.innerText = 'Close'
        span.onclick = function() {
          el.parentNode.removeChild(el)
          storage.set('show-browser-tip', true)
        }
        fragment.appendChild(p)
        fragment.appendChild(span)
        el.innerHTML = ''
        el.appendChild(fragment)
      }
    }
  }
}
